import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Apiurl from "../../Helpers/apiUrl";
import { handleApiError } from "../../Helpers/handleApiError ";

const getToken = () => localStorage.getItem("u_token");

export const fetchClientOpt = createAsyncThunk(
    "client/fetchClientOpt",
    async (_, { rejectWithValue }) => {
        console.log('fetchClientOpt: starting request');
        const token = getToken();
        if (!token) {
            console.warn('fetchClientOpt: no token');
            return rejectWithValue({ message: "No token found, authorization failed." });
        }
        try {
            const response = await axios.get(`${Apiurl}client/clients`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            console.log('fetchClientOpt: response received', response.status);
            return response.data;
        } catch (error) {
            console.error('fetchClientOpt: error', error);
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to fetch clients." });
        }
    },
    {
        condition: (_, { getState }) => {
            const { status } = getState().options || getState().option;
            if (status === 'pending' || status === 'succeeded') {
                return false;
            }
        }
    }
);
export const fetchCollectionOpt = createAsyncThunk(
    "client/fetchCollectionOpt",
    async (_, { rejectWithValue }) => {
        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });
        try {
            const response = await axios.get(`${Apiurl}admin/product/collection`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to fetch clients." });
        }
    }
);
export const fetchCategoryOpt = createAsyncThunk(
    "client/fetchCategoryOpt",
    async (_, { rejectWithValue }) => {
        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });
        try {
            const response = await axios.get(`${Apiurl}category`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to fetch clients." });
        }
    }
);
export const fetchSegmentOpt = createAsyncThunk(
    "client/fetchSegmentOpt",
    async (_, { rejectWithValue }) => {
        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });
        try {
            const response = await axios.get(`${Apiurl}admin/product/segment`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to fetch clients." });
        }
    }
);
export const fetchUserOpt = createAsyncThunk(
    "client/fetchUserOpt",
    async (_, { rejectWithValue }) => {
        const token = getToken();
        if (!token) return rejectWithValue({ message: "No token found, authorization failed." });
        try {
            const response = await axios.get(`${Apiurl}admin/userlist/users`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            handleApiError(error, "Please try again later.");
            return rejectWithValue(error.response?.data || { message: "Failed to fetch clients." });
        }
    }
);

const initialState = {
    clientOpt: [],
    categoryOpt: [],
    collectionOpt: [],
    segmentOpt: [],
    userOpt: [],
    status: "idle",
    error: null,
};

const optionSlice = createSlice({
    name: "option",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchClientOpt.pending, (state) => {
                state.error = null;
                state.status = "pending";
            })
            .addCase(fetchClientOpt.fulfilled, (state, action) => {
                state.clientOpt = action.payload.data;
                state.status = "succeeded";
            })
            .addCase(fetchClientOpt.rejected, (state, action) => {
                state.error = action.payload;
                state.status = "failed";
            })
            .addCase(fetchCategoryOpt.pending, (state) => {
                state.error = null;
                state.status = "pending";
            })
            .addCase(fetchCategoryOpt.fulfilled, (state, action) => {
                state.categoryOpt = action.payload.data;
                state.status = "succeeded";
            })
            .addCase(fetchCategoryOpt.rejected, (state, action) => {
                state.error = action.payload;
                state.status = "failed";
            })
            .addCase( fetchCollectionOpt.pending, (state) => {
                state.error = null;
                state.status = "pending";
            })
            .addCase( fetchCollectionOpt.fulfilled, (state, action) => {
                state.collectionOpt = action.payload.data.map((item)=>item.name);
                state.status = "succeeded";
            })
            .addCase( fetchCollectionOpt.rejected, (state, action) => {
                state.error = action.payload;
                state.status = "failed";
            })
            .addCase(fetchSegmentOpt.pending, (state) => {
                state.error = null;
                state.status = "pending";
            })
            .addCase(fetchSegmentOpt.fulfilled, (state, action) => {
                state.segmentOpt = action.payload.data;
                state.status = "succeeded";
            })
            .addCase(fetchSegmentOpt.rejected, (state, action) => {
                state.error = action.payload;
                state.status = "failed";
            })
            .addCase(fetchUserOpt.pending, (state) => {
                state.error = null;
                state.status = "pending";
            })
            .addCase(fetchUserOpt.fulfilled, (state, action) => {
                state.userOpt = action.payload.data;
                state.status = "succeeded";
            })
            .addCase(fetchUserOpt.rejected, (state, action) => {
                state.error = action.payload;
                state.status = "failed";
            });
    },
});

export default optionSlice.reducer;
